import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output, ViewChild
} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {emtrConstant} from '../../constants/emtrConstants';
import {RuleService} from '../../services/rule-service/rule.service';
import {AssetGroupsTableHeader, TableHeader} from '../../models/security-type.model';
import {FormDataService, SharedService, SharedConstant} from '@ems/shared';
import { TreeTableNodeSelectEvent, TreeTableNodeUnSelectEvent } from 'primeng/treetable';
import { SelectChangeEvent } from 'primeng/select';
import { TreeNode } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ReviewSecurityTypeComponent } from '../review-security-type/review-security-type.component';

@Component({
  selector: 'tr-preset-rules-and-asset-group',
  templateUrl: './preset-rules-and-asset-group.component.html',
  styleUrls: ['./preset-rules-and-asset-group.component.scss']
})
export class PresetRulesAndAssetGroupComponent implements OnInit, AfterViewChecked, OnDestroy {

  @Input() presetRuleIdInput: any;
  @Input() assetGroupsInput: any = {};
  @Input() selectedValues: any = [];
  @Input() globalRuleFlag: any = [];
  @Input() micAGSelectedFlag = false;
  @Output() presetRuleChange = new EventEmitter<any>();
  @Output() presetRuleKey = new EventEmitter<any>();
  @Output() emitWarningMsg = new EventEmitter<any>();
  @Output() assetGroupChange = new EventEmitter<any>();
  @Output() micAssetGroupSelectedFlag = new EventEmitter<boolean>();
  @Output() selectedActionDropdownValue = new EventEmitter<any>();
  @Output() customValue = new EventEmitter<boolean>();
  @ViewChild('reviewSecurityTypeView', { static: true }) reviewSecurityTypeView!: ReviewSecurityTypeComponent;

  presetRuleInput: any;
  expandedPresetRule = true;
  expandedAssetGroup = true;
  expandedMiscAssetGroup = true;
  expandedDigitalAssetGroup = true;
  readonly emtrConstant = emtrConstant;
  getSharedConstant = SharedConstant;
  assetGroups = [];
  assetGroupsWithAttributes = [];
  presetRules = [];
  mutualFundsDropdownValue = [];
  assetGroupsSelection = [];
  showWarningMsg: any;
  presetRuleColumns: any[][] = [];
  presetRuleId: any;
  customAssetGrpId: any;
  assetGroupsTreeData: any = [];
  selectedNodes: any = [];
  newSelectedNodes: any = [];
  checked = false;
  superParentNode: any;
  rowNodeArray: any = [];
  childrenNode: any = [];
  columnsLevel: any[];
  assetGroupTableHeader: TableHeader[] = AssetGroupsTableHeader;
  count = 0;
  index = 0;
  selectedAction: any;
  selectedCustomAssetGrp = [];
  customAssetGrp = [];
  customAssetGrpFlag = false;
  private readonly clientInfoSubscription: Subscription;
  private treeCheckboxLabelTimer: ReturnType<typeof setTimeout> | null = null;
  miscellaneousAssetGrpForm = this.fb.group({});
  miscAssetGroups = [];
  debtAssGrpName = '';
  businessUnit: any = '';
  assetGrpLabel: any = '';
  securityData = [];
  multiLevelSecurityType: any = {};
  custom = false;
  etfLimPartnershipObj = [];
  selectionKeys: {
    [key: string]: {
      checked: boolean;
      partialChecked?: boolean
    }
  } = {};
  clearSelectedNode: any[] = [];
  digitalAssetGroups: any[];
  digitalAssetGroupsTreeData: any;
  selectedDigitalNodes: TreeNode<any>[];
  spotCryptoDisabled = false;

  constructor(public ruleService: RuleService, public formDataService: FormDataService, public el: ElementRef, public fb: UntypedFormBuilder, @Inject('entitlementConst') public entitlementConst, public sharedService: SharedService, public cdr:ChangeDetectorRef) {
    this.clientInfoSubscription = this.sharedService.clientInformation.subscribe(clientInfo => {
      this.businessUnit = clientInfo && clientInfo.businessUnit;
    });
  }

  ngOnInit() {
    this.columnsLevel = this.assetGroupTableHeader;
    /* Set CUSTOM ASSET GROUP as default selection */
    this.presetRuleInput = this.presetRuleIdInput ? this.presetRuleIdInput : this.emtrConstant.presetRules.customAssetGroupText;
    /* Set label for asset group section based on the client selected (DBS/RBS client) */
    this.assetGrpLabel = this.businessUnit && this.businessUnit === this.getSharedConstant.rbsBUText ? this.emtrConstant.presetRules.assetGroupText : this.emtrConstant.presetRules.assetGroupsAndAttributesText;
    this.presetRuleKey.emit(this.presetRuleInput);
    /* Set 'Select' as default selection in the OER dropdown */
    this.selectedAction = {name: 'Select', value: ''};
    if (this.ruleService.assetGrpCache().length > 0 && (this.businessUnit === this.ruleService.assetGrpCache()[0].bu || this.businessUnit === '')) {
      const enableSpotCrypto = this.sharedService.applicationInfo?.data?.enableSpotCrypto === true;
      const spotCryptoCode = this.emtrConstant.ruleSteps.step2.spotCryptoCode;
      const ruleHasSpotCrypto = Array.isArray(this.assetGroupsInput) &&
        this.assetGroupsInput.some(ag => ag.code === spotCryptoCode);
      if (!enableSpotCrypto && ruleHasSpotCrypto) {
        this.spotCryptoDisabled = true;
      }
      const cache = this.ruleService.assetGrpCache();
      const cacheHasSpotCrypto = cache.some(val => val.code === spotCryptoCode);
      if (!enableSpotCrypto && ruleHasSpotCrypto) {
        /* Flag is off but rule was saved with Spot Crypto — keep it visible but disabled.
           If the cached asset groups were populated without Spot Crypto (flag off path),
           re-fetch from the API so the Spot Crypto group can be displayed (disabled). */
        if (cacheHasSpotCrypto) {
          this.fetchAssetGroups(cache);
        } else {
          this.getAssetGroups();
        }
      } else {
        this.fetchAssetGroups(enableSpotCrypto ? cache : cache.filter(val => val.code !== spotCryptoCode));
      }
    } else {
      this.getAssetGroups();
    }
    if (this.businessUnit !== 'DBS' && this.businessUnit !== 'SPS') {
      if (this.ruleService.presetRulesCache().length > 0) {
        this.fetchPresetRules(this.ruleService.presetRulesCache());
      } else {
        this.getPresetRules();
      }
      this.assignAssetGroupForOBPRule(); 
    } else {
      const localObj = {assetGroups: this.assetGroupsInput};
      /* Custom flag will be set to true for MF preset rules selection only and for DBS asset group selection custom flag will be set to false */
      this.custom = false;
      setTimeout(() => {
        this.updateAssetGroup(localObj);
        if (this.assetGroupsInput.length > 0) {
          localObj.assetGroups.forEach(obj => {
            this.selectionKeys[obj.code] = {checked: true, partialChecked: false};
            if (obj.attributes && obj.attributes.length) {
              obj.attributes.forEach(attr => {
                this.selectionKeys[attr.code] = {checked: true, partialChecked: false};
              });
            }
          });
        }
        this.updateCheckboxCssForDBS();
        this.emitSelectedAGandPresetRule(this.presetRuleId, this.presetRuleInput, this.assetGroupsSelection, false);
      }, 500);
    }
    if (!this.globalRuleFlag && this.micAGSelectedFlag) {
      this.miscellaneousAssetGrpForm.reset();
      this.assetGroupsInput = [];
    }
  }

  ngAfterViewChecked() {
    this.scheduleTreeCheckboxInputLabels();
  }

  ngOnDestroy() {
    if (this.clientInfoSubscription) {
      this.clientInfoSubscription.unsubscribe();
    }
    if (this.treeCheckboxLabelTimer) {
      clearTimeout(this.treeCheckboxLabelTimer);
      this.treeCheckboxLabelTimer = null;
    }
  }

  private scheduleTreeCheckboxInputLabels() {
    if (this.treeCheckboxLabelTimer) {
      clearTimeout(this.treeCheckboxLabelTimer);
    }
    this.treeCheckboxLabelTimer = setTimeout(() => {
      this.applyTreeCheckboxInputLabels();
      this.treeCheckboxLabelTimer = null;
    }, 0);
  }

  getAssetGroups() {
    /* Fetch Asset group and global asset group */
    this.ruleService.getAssetGroups().subscribe(assetGrp => {
      const enableSpotCrypto = this.sharedService.applicationInfo?.data?.enableSpotCrypto === true;
      const spotCryptoCode = this.emtrConstant.ruleSteps.step2.spotCryptoCode;
      const ruleHasSpotCrypto = Array.isArray(this.assetGroupsInput) &&
        this.assetGroupsInput.some(ag => ag.code === spotCryptoCode);
      if (!enableSpotCrypto && ruleHasSpotCrypto) {
        /* Flag is off but rule was saved with Spot Crypto — keep it visible but disabled */
        this.spotCryptoDisabled = true;
        this.fetchAssetGroups(assetGrp.data);
      } else {
        this.fetchAssetGroups(enableSpotCrypto
          ? assetGrp.data
          : assetGrp.data.filter(val => val.code !== spotCryptoCode));
      }
    });
  }

  getPresetRules() {
    /* Fetch preset rules to be displayed and the corresponding asset group details */
    this.ruleService.getPresetRules().subscribe(presetData => {
      this.fetchPresetRules(presetData.data);
    });
  }

  fetchPresetRules(presetData) {
      this.presetRules = presetData;
      const sortedPresetRules = [...(this.presetRules || [])].sort((a, b) => Number(a.order) - Number(b.order));
      this.presetRuleColumns = this.groupPresetRulesByOrderColumn(sortedPresetRules);
      this.presetRules?.forEach(presetRuleData => {
        if (presetRuleData.key === this.emtrConstant.presetRules.customAssetGroupText) {
          this.customAssetGrpId = presetRuleData.id;
        }
      });

      

      /* Set the selected preset rule and asset groups value - data sent from parent component */
      setTimeout(() => {
        /* To update the secCatgs value in the preset rules from the asset group secCatgs. In preset rules we only get the missing securities other than asset groups
        * hence to populate all the required value we need to get all the securities from preset rules and asset groups */
        if (this.ruleService.presetRulesCache().length === 0) {
          /* Snapshot the original (API-level) secCatgs on each rule BEFORE the merge so that
             getSelectedAssetGroups() can seed the Review Security modal with the preset-specific
             securities that are not carried on individual tree nodes. */
          this.presetRules.forEach(rule => {
            rule.presetOnlySecCatgs1 = [...(rule.secCatgs1 || [])];
            rule.presetOnlySecCatgs2 = [...(rule.secCatgs2 || [])];
            rule.presetOnlySecCatgs3 = [...(rule.secCatgs3 || [])];
          });
          this.presetRules = this.ruleService.updateSecCatgsInPresentRule(this.presetRules, this.assetGroups);
          this.ruleService.setPresetRulesCacheData(this.presetRules);
        }
        if (this.presetRuleIdInput) {
          this.presetRuleId = this.presetRuleIdInput;
          this.presetRules.forEach(presetRuleData => {
            if (this.presetRuleId === presetRuleData.id) {
              if  (presetRuleData.id === this.customAssetGrpId) {
                this.customAssetGrpFlag = true;
              }
              this.presetRuleInput = presetRuleData.key;
              if (this.micAGSelectedFlag && this.globalRuleFlag) {
                this.updateMiscAssetGroupSelection();
              } else {
                this.updatePresetRule();
              }
            }
          });
        }
      }, 500);
  }

  get presetRuleGridColumns(): string {
    /* Keep the grid in sync with however many order-derived columns exist. */
    const columnCount = this.presetRuleColumns.length || 1;

    return `repeat(${columnCount}, minmax(0, 1fr))`;
  }

  private groupPresetRulesByOrderColumn(sortedPresetRules: any[]): any[][] {
    const groupedColumns = new Map<number, any[]>();

    sortedPresetRules.forEach(item => {
      /* Only accept numeric order values; malformed, null or undefined order is dropped
         so it cannot silently collapse into the first visual column. */
      if (item.order === null || item.order === undefined || item.order === '') {
        return;
      }
      const orderValue = Number(item.order);
      if (!Number.isFinite(orderValue)) {
        return;
      }

      /* The hundreds digit in order defines the visual column: 1xx -> first, 2xx -> second, etc. */
      const columnNumber = Math.floor(orderValue / 100);

      if (!groupedColumns.has(columnNumber)) {
        groupedColumns.set(columnNumber, []);
      }

      groupedColumns.get(columnNumber)?.push(item);
    });

    return Array.from(groupedColumns.entries())
      .sort((a, b) => a[0] - b[0])
      .map(([, rules]) => rules);
  }

  /* Fetch asset group to be displayed */
  fetchAssetGroups(assetGrp) {
    setTimeout(() => {
      if (this.assetGroupsInput && this.assetGroupsInput.some(val => val.code === this.emtrConstant.ruleSteps.step2.mutualFundsCode)) {
        this.assetGroupsInput.forEach(data => {
          if (data.attributes && Array.isArray(data.attributes)) {
            data.attributes.forEach(operation => {
              if (operation.code === this.emtrConstant.ruleSteps.step2.operatingNetExpenseRatioCode) {
                this.selectedAction = {name: operation.value, code : operation.code, value: operation.value };
              }
            });
          }
        });
      }
    }, 1250);
    // Remove Digital Asset Exposure from the regular Asset Groups table.
    this.assetGroups = assetGrp.filter(val => val.code !== this.emtrConstant.ruleSteps.step2.digitalAssetGroupCode);
    this.digitalAssetGroups = assetGrp.filter(val => val.code === this.emtrConstant.ruleSteps.step2.digitalAssetGroupCode);
    /* Set Mutual funds Object in shared service for use in Rule Step2 component */
    this.sharedService.mutualFundsObj = this.assetGroups.find(val => val.code === this.emtrConstant.ruleSteps.step2.mutualFundsCode);

    if (assetGrp.length > 0) {
      this.ruleService.setAssetGrpCacheData(assetGrp);
      assetGrp.forEach(val => {
        // Add null check before forEach
        if (val.attributes && Array.isArray(val.attributes)) {
          val.attributes.forEach(type => {
            /* Set Operating / Net Expense Ratio dropdown value */
            if (type.htmlType === 'dropdown') {
              const newObj = {name: 'Select', value: ''};
              this.mutualFundsDropdownValue.push(newObj);
              type.value.forEach(percentage => {
                const obj = {name: percentage, code: type.code, value: percentage};
                this.mutualFundsDropdownValue.push(obj);
              });
            }
          });
        }

        /* Forming miscellaneous asset group array to create form control and to display miscellaneous asset group on the screen */
        if (val.code && val.code.startsWith('g-')) {
          const localVal = {id: val.id, name: val.name, code: val.code, attributes: val.attributes || [], secCatgs1: val.secCatgs1, secCatgs2: val.secCatgs2, secCatgs3: val.secCatgs3};
          this.miscAssetGroups.push(localVal);
          if (val.code === this.emtrConstant.ruleSteps.step2.debtAGCode && val.attributes && val.attributes[0]) {
            this.debtAssGrpName = val.attributes[0].name;
          }
        }
      });
    }

    /* Creating form controls for Miscellaneous asset group names */
    this.miscAssetGroups.forEach(asstGrpVal => {
      this.miscellaneousAssetGrpForm.addControl(asstGrpVal.name, this.fb.control(''));
      if (this.validateRoleForOBP()) {
        this.miscellaneousAssetGrpForm.get(asstGrpVal.name).disable();
      }
    });

    /* Format the response of asset group to Treetable JSON Format */
    this.assetGroupsTreeData = this.formatJson(this.assetGroups);

    /* Format the Digital Asset Groups to Treetable JSON Format */
    this.digitalAssetGroupsTreeData = this.formatJson(this.digitalAssetGroups);

    this.assetGroupsTreeData?.forEach((assetGroupType: any) => {
      /* Store the object for ETF- limited Partnership so that it can be pushed to selectedArr array if EQ-Limited Partnership is selected */
      if (assetGroupType.data.code === this.emtrConstant.presetRules.etfCode) {
        assetGroupType.children.forEach((child) => {
          if (child.data.code === this.emtrConstant.presetRules.etfLimitedPartnershipCode) {
            this.etfLimPartnershipObj = child;
          }
        });
      }
    });
  }

  /* Formatting the Backend JSON to Treetable JSON Format */
  formatJson(data) {
    return data.map(dataEle => {
      let subLevels = [];
      if (dataEle.attributes && Array.isArray(dataEle.attributes)) {
        dataEle.attributes.forEach(value => {
          if (value) {
            value.parent = dataEle.code;
          }
          subLevels.push({data: value});
        });
      }
      this.assetGroupsWithAttributes.push({
        id: dataEle.id,
        name: dataEle.name,
        code: dataEle.code ? dataEle.code : '',
        attributes: dataEle.attributes ? dataEle.attributes : []
      });
      delete dataEle.attributes;
      /* Creating object of a Parent & child relation */
      if (subLevels) {
        const obj = {
          data: dataEle,
          children: subLevels,
          expanded: true,
          name: dataEle.name,
          code: dataEle.code,
          label: dataEle.label ? dataEle.label : ''
        };
        subLevels = [];
        return obj;
      } else {
        /* Creating object of a Parent with no attributes/children */
        const obj = {
          data: dataEle,
          children: [],
          expanded: false,
        };
        return obj;
      }
    });
  }

  /* Value creation for each checkbox/node of Treetable */
  isParentNode(rowNode) {
    this.count++;
    /* rowNodeArray will contain the value of all the checkbox in asset group table -> helps in pushing data into
    selectedNode array when any preset rule is selected or during the edit flow */
    if (rowNode && this.rowNodeArray.indexOf(rowNode.node) === -1) {
      this.rowNodeArray.push(rowNode.node);
    }

    /* Assign the node value to parent checkbox */
    if (rowNode && !rowNode.level) {
      this.superParentNode = rowNode;
      this.childrenNode = [];
      this.count = 0;
    }

    /* Create an array children node value to assign value to children checkbox */
    if (rowNode && (rowNode.parent && this.count === 1)) {
      if (rowNode.parent.children.length > 0) {
        rowNode.parent.children.forEach(data => {
          const newObj = {
            level: 1,
            node: {data: data.data, parent: rowNode.parent},
            parent: rowNode.parent,
          };
          this.childrenNode.push(newObj);
        });
      }
      return true;
    } else {
      /*to print parent which does not have children*/
      if (this.count === 0 && rowNode && rowNode.node.children.length === 0) {
        return true;
      } else {
        return false;
      }
    }
  }

  togglePresetRule() {
    this.expandedPresetRule = !this.expandedPresetRule;
  }

  toggleAssetGroup() {
    this.expandedAssetGroup = !this.expandedAssetGroup;
  }

  toggleDigitalAssetGroup() {
    this.expandedDigitalAssetGroup = !this.expandedDigitalAssetGroup;
  }

  toggleMiscellaneousAssetGroup() {
    this.expandedMiscAssetGroup = !this.expandedMiscAssetGroup;
  }

  updatePresetRule(event?) {
    /* Remove the warning msg on parent component when any preset rule is selected */
    this.showWarningMsg = this.globalRuleFlag ? '' : this.getSharedConstant.RBS.warningMsgForPresetRulesOrSecurities;
    this.emitWarningMsg.emit(this.showWarningMsg);

    /* Clear out the miscellaneous asset group selection, when any preset rule is selected */
    this.miscellaneousAssetGrpForm.reset();

    /* Clear assetGroupsSelection, selectedNodes and selectedArr before setting the new values */
    this.assetGroupsSelection = [];
    this.selectedNodes = [];
    
    /* Clear security value selected on Review Security Details before setting the new values */
    this.multiLevelSecurityType = [];
    
    /* Clear digital asset group selection */
    this.selectedDigitalNodes = [];

    /* Set 'Select' as default selection in the OER dropdown */
    this.selectedAction = {name: 'Select', value: ''};
    const selectedArr = [];
    let localRulesForDigital = null; // Store localRules for digital asset groups

    /* Add and mark partialSelected field as false for all the nodes */
    const localRowNode = this.rowNodeArray;
    localRowNode.forEach(nodeVal => {
      nodeVal.partialSelected = false;
    });

    /* Iterate through the presetRules list and through corresponding assetGroups associated with each the preset rule for
    making the asset group selection */
    this.presetRules.forEach(rule => {
      const secCatgs = {
        secCatgs1: [],
        secCatgs2: [],
        secCatgs3: []
      }

      /* Compare the selected preset rule with each key value iterated from the presetRules list */
      if (this.presetRuleInput === rule.key) {
        this.presetRuleId = rule.id;

        /* Set the custom flag to the value given be api, custom will be true for all MF rules else for other rules custom will be false */
        this.custom = rule.custom;

        /* The selected rule will have all the required secCatgs, and to form the selected security array to display on the review security details modal call fetchAndPupulateSecurityTypeList */
        secCatgs.secCatgs1 = rule.secCatgs1 ? rule.secCatgs1 : [];
        secCatgs.secCatgs2 = rule.secCatgs2 ? rule.secCatgs2 : [];
        secCatgs.secCatgs3 = rule.secCatgs3 ? rule.secCatgs3 : [];

        if (this.presetRuleId !== this.customAssetGrpId) {
          /* Set the customAssetGrpFlag to false if the selected preset rule is not CUSTOM ASSET GROUP */
          this.customAssetGrpFlag = false;
        }
        if (rule.assetGroups.length > 0 || this.customAssetGrpFlag) {
          /* Fetch the assetGroups info from the assetGroupInput if the selected preset rule is CUSTOM ASSET GROUP
           else fetch it from the preset rule list returned from api */
          let localRules;
          let flagToUpdateCachedData = false;
          if ((!event && this.presetRuleId && this.assetGroupsInput && this.assetGroupsInput.length)) {
            localRules = { assetGroups: this.assetGroupsInput };
            flagToUpdateCachedData = true;
          } else {
            localRules = rule;
            flagToUpdateCachedData = false;
          }
          
          // Store for digital asset group processing
          localRulesForDigital = localRules;
          
          /* Iterate through the assetGroups corresponding to the selected preset rule to make the asset group selection */
          localRules.assetGroups.forEach(assetGrp => {
            /* Skip digital asset groups - they will be handled separately */
            if (assetGrp.code === this.emtrConstant.ruleSteps.step2.digitalAssetGroupCode) {
              return;
            }
            
            /* Mainly this section is for loading the securites of the selected asset group, when user lands on rule step2 from step1/step3 */
            if (this.customAssetGrpFlag) {
              /* Custom flag will be set to true for MF preset rules selection only and for any asset group selection custom flag will be set to false */
              this.custom = false;
              this.assetGroups.some(grp => assetGrp.code === grp.code && grp.secCatgs1 ? grp.secCatgs1.filter(security => secCatgs.secCatgs1.indexOf(security) === -1 ? secCatgs.secCatgs1.push(security) : '') : '');
              this.assetGroups.some(grp => assetGrp.code === grp.code && grp.secCatgs2 ? grp.secCatgs2.filter(security => secCatgs.secCatgs2.indexOf(security) === -1 ? secCatgs.secCatgs2.push(security) : '') : '');
              this.assetGroups.some(grp => assetGrp.code === grp.code && grp.secCatgs3 ? grp.secCatgs3.filter(security => secCatgs.secCatgs3.indexOf(security) === -1 ? secCatgs.secCatgs3.push(security) : '') : '');
            }
            if (assetGrp.attributes && assetGrp.attributes.length > 0) {
              assetGrp.attributes.forEach(attributes => {
                /* Iterate through rowNodeArray that contain the value of all the checkbox in asset group table to push the asset group
                corresponding to the selected preset rule into selectedNode array --> pushing the data of child selection */
                this.rowNodeArray.forEach(rowData => {
                  if (rowData.parent && rowData.data.code === attributes.code && rowData.parent.data.code === assetGrp.code) {
                    rowData.parent.partialSelected = true;
                    rowData.partialSelected = false;
                    if (this.emtrConstant.ruleSteps.step2.operatingNetExpenseRatioCode === attributes.code) {
                      rowData.selectedValueIs = attributes.value;
                    }
                    selectedArr.push(rowData);
                  }
                });
              });
            } else {
              /* Iterate through rowNodeArray that contain the value of all the checkbox in asset group table to push the asset group
                corresponding to the selected preset rule into selectedNode array --> pushing the data of parent selection */
              this.rowNodeArray.forEach(rowData => {
                if (rowData.data.code === assetGrp.code) {
                  rowData.partialSelected = false;
                  selectedArr.push(rowData);
                }
              });
            }
          });

          /* Call fetchAndPupulateSecurityTypeList to populate the security modal with fetched secCatgs  */
          this.fetchAndPupulateSecurityTypeList(secCatgs);

          let localAssetGrp = [];
          let cachedAssetGroup = [];

          localAssetGrp = this.updateAssetGroupsDataWithCode(localRules.assetGroups);
          if (flagToUpdateCachedData === true) {
            cachedAssetGroup = this.updateAssetGroupsDataWithCode(rule.assetGroups);
          }

          this.assetGroupsSelection = localAssetGrp;
        }
      }
    });
    this.selectedNodes = selectedArr;
    this.updateCheckboxCss();
    
    // Handle digital asset groups - load for all preset rules if data exists
    if (localRulesForDigital && localRulesForDigital.assetGroups) {
      this.loadDigitalAssetGroups(localRulesForDigital);
    }
    
    this.emitSelectedAGandPresetRule(this.presetRuleId, this.presetRuleInput, this.assetGroupsSelection, false);
  }

  updateAssetGroupsDataWithCode(assetGroups) {
    let assetGrpValue = [];
    const localAssetGrp = [];
    this.assetGroupsWithAttributes.forEach(assetGrpsVal => {
    assetGroups.forEach(astGrp => {
      if (assetGrpsVal.code === astGrp.code) {
        assetGrpValue = [];
        astGrp.code = assetGrpsVal.code ? assetGrpsVal.code : '';
        astGrp.attributes.forEach((userSelected) => {
          const matchedMF = assetGrpsVal.attributes.filter((MFtype) => MFtype.code === userSelected.code);
          if (matchedMF && matchedMF.length > 0) {
            userSelected.code = matchedMF[0].code ? matchedMF[0].code : '';
            assetGrpValue.push({ name: userSelected.name, code: userSelected.code, value: userSelected.value });
          }
        });
        localAssetGrp.push({ id: assetGrpsVal.id, name: astGrp.name, code: astGrp.code, attributes: assetGrpValue });
      }
    });
  });
    return localAssetGrp;
  }

  updateAssetGroup(localRules) {
    /* Clear security value selected on Review Security Details before setting the new values */
    this.multiLevelSecurityType = [];

    const selectedArr = [];
    /* Iterate through the assetGroups corresponding to the selected preset rule to make the asset group selection */
    localRules.assetGroups.forEach(assetGrp => {
      /* Skip digital asset groups - they will be handled separately */
      if (assetGrp.code === this.emtrConstant.ruleSteps.step2.digitalAssetGroupCode) {
        return;
      }
      
      if (assetGrp.attributes && assetGrp.attributes.length > 0) {
        assetGrp.attributes.forEach(attributes => {
          /* Iterate through rowNodeArray that contain the value of all the checkbox in asset group table to push the asset group
          corresponding to the selected preset rule into selectedNode array --> pushing the data of child selection */
          this.rowNodeArray.forEach(rowData => {
            if (rowData.data.code === attributes.code && rowData.parent.data.code === assetGrp.code) {
              rowData.parent.partialSelected = true;
              rowData.partialSelected = false;
              if (this.emtrConstant.ruleSteps.step2.operatingNetExpenseRatioCode === attributes.code) {
                rowData.selectedValueIs = attributes.value;
              }

              /* This section is for loading the securites of the selected DBS asset group, when user lands on rule step2 from step1/step3 */
              const secCatgs = {
                secCatgs1: rowData.parent.data.secCatgs1 ? rowData.parent.data.secCatgs1 : [],
                secCatgs2: rowData.parent.data.secCatgs2 ? rowData.parent.data.secCatgs2 : [],
                secCatgs3: rowData.parent.data.secCatgs3 ? rowData.parent.data.secCatgs3 : []
              }
              this.fetchAndPupulateSecurityTypeList(secCatgs);
              selectedArr.push(rowData);
            }
          });
        });
      } else {
        /* Iterate through rowNodeArray that contain the value of all the checkbox in asset group table to push the asset group
          corresponding to the selected preset rule into selectedNode array --> pushing the data of parent selection */
        this.rowNodeArray.forEach(rowData => {
          if (rowData.data.code === assetGrp.code) {
            rowData.partialSelected = false;
            selectedArr.push(rowData);
          }
        });
      }
    });

    const localAssetGrp = [];
    let assetGrpValue = [];
    this.assetGroupsWithAttributes.forEach(assetGrpsVal => {
      localRules.assetGroups.forEach(grp => {
        /* Skip digital asset groups from regular asset group processing */
        if (grp.code === this.emtrConstant.ruleSteps.step2.digitalAssetGroupCode) {
          return;
        }
        
        if (assetGrpsVal.code === grp.code) {
          assetGrpValue = [];
          grp.code = assetGrpsVal.code ? assetGrpsVal.code : '';
          grp.attributes.forEach( (userSelected) => {
            const matchedMF = assetGrpsVal.attributes.filter( (mFtype) => mFtype.code === userSelected.code) ;
            if (matchedMF && matchedMF.length > 0) {
              userSelected.code = matchedMF[0].code ? matchedMF[0].code : '';
              assetGrpValue.push({name: userSelected.name, code: userSelected.code, value: userSelected.value});
            }
          });
          localAssetGrp.push({id: assetGrpsVal.id, name: grp.name, code: grp.code, attributes: assetGrpValue});
        }
      });
    });
    this.assetGroupsSelection = localAssetGrp;
    this.selectedNodes = selectedArr;
    this.newSelectedNodes = selectedArr;
    
    setTimeout(() => {
      // Also populate selectedDigitalNodes if there are digital asset groups in the input
      this.loadDigitalAssetGroups(localRules);
      // After loading digital asset groups, update assetGroupsSelection to include them  
      this.getSelectedAssetGroups();
    });
  }
  
  loadDigitalAssetGroups(localRules) {
    /* Populate selectedDigitalNodes from assetGroupsInput when navigating back from step 3/4 */
    const digitalSelectedArr = [];
    
    localRules.assetGroups.forEach(assetGrp => {
      // Check if this is a digital asset group
      if (assetGrp.code === this.emtrConstant.ruleSteps.step2.digitalAssetGroupCode) {
        if (assetGrp.attributes && assetGrp.attributes.length > 0) {
          // Find the parent node to check if all children are selected
          let parentNode = null;
          this.rowNodeArray.forEach(rowData => {
            if (rowData.data.code === assetGrp.code && !rowData.parent) {
              parentNode = rowData;
            }
          });
          
          // Check if ALL children are in attributes (parent was originally selected)
          const allChildren = parentNode?.children || [];
          const allChildrenSelected = allChildren.length > 0 && 
            allChildren.every(child => 
              assetGrp.attributes.some(attr => attr.code === child.data.code)
            );
          
          if (allChildrenSelected) {
            // All children are selected, so select the parent AND all children
            if (parentNode) {
              parentNode.partialSelected = false; // Full selection, not partial
              digitalSelectedArr.push(parentNode);
            }
            // Also add all child nodes so they show checkmarks too
            assetGrp.attributes.forEach(attributes => {
              this.rowNodeArray.forEach(rowData => {
                if (rowData.data.code === attributes.code && rowData.parent && rowData.parent.data.code === assetGrp.code) {
                  rowData.partialSelected = false;
                  digitalSelectedArr.push(rowData);
                }
              });
            });
          } else {
            // Only specific children are selected - mark parent as partial
            if (parentNode) {
              parentNode.partialSelected = true;
            }
            assetGrp.attributes.forEach(attributes => {
              this.rowNodeArray.forEach(rowData => {
                if (rowData.data.code === attributes.code && rowData.parent && rowData.parent.data.code === assetGrp.code) {
                  rowData.partialSelected = false;
                  // Mark the parent as partial
                  if (rowData.parent) {
                    rowData.parent.partialSelected = true;
                  }
                  digitalSelectedArr.push(rowData);
                }
              });
            });
          }
        }
      }
    });
    
    this.selectedDigitalNodes = digitalSelectedArr;
    this.cdr.detectChanges();
  }

  updateCheckboxCssForDBS() {
    const wholeArray = this.el.nativeElement.querySelectorAll('td.assetGrptd');
    /* Remove the css from all checkboxes before adding any new css */
    wholeArray.forEach(element => {
      this.updateAssetGroupSelection('remove', '', element);
    });

    /* Adding css for parent and the child checkbox */
    this.selectedNodes.forEach((rowData) => {
      wholeArray.forEach(element => {
        const outerText = element.outerText;
        /* Adding the css to the parent checkbox, whose children are selected */
        if (rowData.parent) {
          if (element.outerText === rowData.parent.data.name) {
            this.updateAssetGroupSelection('add', 'check', element);
          } else if (element.outerText === rowData.data.name && element.parentElement.outerText.includes(rowData.parent.data.name)) {
            /* Adding the css to the children checkbox and to parent checkbox, whose children are not selected */
            this.updateAssetGroupSelection('add', 'check', element);
          }
        } else if (element.parentElement.outerText.includes(rowData.data.name)) {
          this.updateAssetGroupSelection('add', 'check', element);
        }
      });
    });
  }

  updateCheckboxCss() {
    const wholeArray = this.el.nativeElement.querySelectorAll('td.assetGrptd');
    /* Remove the css from all checkboxes before adding any new css */
    wholeArray.forEach(element => {
      this.updateAssetGroupSelection('remove', '', element);
    });

    if (wholeArray && wholeArray.length > 0) {
      /* Adding hyphen to Mutual Fund parent checkbox when value is selected in the Operating / Net Expense Ratio dropdown */
      if (this.selectedAction && this.selectedAction.value !== '') {
        this.selectedActionDropdownValue.emit(this.selectedAction);
      } else {
        this.selectedActionDropdownValue.emit(undefined);
      }
    }

    /* Adding css for parent and the child checkbox */
    this.selectedNodes.forEach((rowData) => {
      wholeArray.forEach(element => {
        const outerText = element.outerText;
        /* Adding the css to the parent checkbox, whose children are selected */
        if (rowData.parent) {
          if (element.outerText === rowData.parent.data.name || (rowData.parent.data.code === this.emtrConstant.ruleSteps.step2.optionsAG && outerText.toUpperCase().includes('OPTIONS' + '\n' + 'NOTE: CLOSING ORDERS ALWAYS PERMITTED'))) {
            if (this.businessUnit !== 'DBS') {
            this.updateAssetGroupSelection('add', 'hyphen', element);
            } else {
            this.updateAssetGroupSelection('remove', 'hyphen', element);
            this.updateAssetGroupSelection('add', 'check', element);
            }
          } else if (element.outerText === rowData.data.name && element.parentElement.outerText.includes(rowData.parent.data.name)) {
            /* Adding the css to the children checkbox and to parent checkbox, whose children are not selected */
            this.updateAssetGroupSelection('add', 'check', element);
          }
        } else if (element.outerText === rowData.data.name || (rowData.data.code === this.emtrConstant.ruleSteps.step2.optionsAG && outerText.toUpperCase().includes('OPTIONS' + '\n' + 'NOTE: CLOSING ORDERS ALWAYS PERMITTED'))) {
          this.updateAssetGroupSelection('add', 'check', element);
        }
      });
    });
  }



   /* istanbul ignore start */
  updateAssetGroupSelection(action, item, element) {
    const entireCheckedArray1 = element.querySelector('.p-checkbox-box');
    const entireCheckedArray2 = element.querySelector('.p-checkbox-icon');
    if (entireCheckedArray1 && entireCheckedArray2) {
      /* Clear the previous selection made on Asset Groups section */
      if (action === 'remove') {
        entireCheckedArray1.classList.remove('p-highlight');
        entireCheckedArray2.classList.remove('pi');
        entireCheckedArray2.classList.remove('pi-check');
        entireCheckedArray2.classList.remove('pi-minus');
      } else {
        /* Add the css to select the asset groups corresponding to the preset rule selected */
        entireCheckedArray1.classList.add('p-highlight');
        entireCheckedArray2.classList.add('pi');
        if (item === 'hyphen') {
          entireCheckedArray2.classList.add('pi-minus');
        } else {
          entireCheckedArray2.classList.remove('pi-minus');
          entireCheckedArray2.classList.add('pi-check');
        }
      }
    }

    setTimeout(() => {
     this.highlightParent();
    });
  }
  /* istanbul ignore end */

  setWarningMsg() {
    if (this.presetRuleInput !== this.emtrConstant.presetRules.customAssetGroupText) {
      /* To show the warning msg on parent component when changes made in asset groups */
      this.showWarningMsg = this.emtrConstant.presetRules.assetGrpWarningMsg;
      this.emitWarningMsg.emit(this.showWarningMsg);

      /* When changes is made in asset groups set preset rule to CUSTOM ASSET GROUP */
      // this.presetRuleInput = this.emtrConstant.presetRules.customAssetGroupText;
    }
  }

  getSelectedAssetGroups() {
    // if (this.presetRuleInput === this.emtrConstant.presetRules.customAssetGroupText) {
      /* Preserve the custom flag from the selected preset rule so that adding extra asset groups
         or attributes does not reset it. custom=true is meaningful for MF preset rules. */
      const currentRule = this.presetRules?.find(r => r.id === this.presetRuleId);
      this.custom = currentRule ? (currentRule.custom ?? false) : false;

      let obj = [];
      this.selectedCustomAssetGrp = [];
      this.customAssetGrp = [];

      /* Clear security value selected on Review Security Details before setting the new values */
      this.multiLevelSecurityType = [];

      /* For named presets: seed once from the preset's own (API-level) secCatgs — stored as
         presetOnlySecCatgs before updateSecCatgsInPresentRule merged the asset-group secCatgs into
         the rule. Warm-cache rules already carry presetOnlySecCatgs (snapshotted before
         setPresetRulesCacheData is called), so the ?? fallback to secCatgs1 is a defensive
         guard only and is not expected to be reached in normal flows.
         These preset-specific securities are not on individual tree nodes, so they must be
         included regardless of which nodes are checked or unchecked.
         Per-node tree secCatgs are then added below and DO respond to check/uncheck.
         PRECONDITION: presetOnlySecCatgs and per-node secCatgs must be disjoint (guaranteed by
         the API). If they overlap, multiLevelSecurityType will contain duplicate entries. */
      if (currentRule && this.presetRuleId !== this.customAssetGrpId) {
        this.fetchAndPupulateSecurityTypeList({
          secCatgs1: currentRule.presetOnlySecCatgs1 ?? currentRule.secCatgs1 ?? [],
          secCatgs2: currentRule.presetOnlySecCatgs2 ?? currentRule.secCatgs2 ?? [],
          secCatgs3: currentRule.presetOnlySecCatgs3 ?? currentRule.secCatgs3 ?? [],
        });
      }

      /* Add per-node secCatgs and process REGULAR asset groups in a single pass */
      this.selectedNodes.forEach(rowData => {
        /* Per-node secCatgs — responds correctly to check/uncheck */
        this.fetchAndPupulateSecurityTypeList({
          secCatgs1: rowData.parent ? (rowData.parent.data.secCatgs1 ?? []) : (rowData.data.secCatgs1 ?? []),
          secCatgs2: rowData.parent ? (rowData.parent.data.secCatgs2 ?? []) : (rowData.data.secCatgs2 ?? []),
          secCatgs3: rowData.parent ? (rowData.parent.data.secCatgs3 ?? []) : (rowData.data.secCatgs3 ?? []),
        });
        this.customAssetGrp = [...this.selectedCustomAssetGrp];
        /* When parent node/checkbox is selected, attributes array should be empty for RBS*/
        if (rowData.children && rowData.children.length >= 0) {
          let childAttr = [];
          if (this.businessUnit === 'DBS') {
            childAttr = rowData.children.map(childEl => {
              return {
                name: childEl.data.name,
                code: childEl.data.code ? childEl.data.code : '',
                value: 'true',
              };
            });
          }
          this.selectedCustomAssetGrp.push({
            id: rowData.data.id,
            name: rowData.data.name,
            code: rowData.data.code ? rowData.data.code : '',
            attributes: childAttr && childAttr.length ? childAttr : [],
          });
          if (rowData.children.length > 0 && this.businessUnit !== 'DBS') {
            /* Remove the duplicate entry -> when child was selected first n then parent selection was made */
            const dupCount = this.selectedCustomAssetGrp.findIndex(a => a.code === rowData.code && a.attributes.length === rowData.children.length);
            if (dupCount !== -1) {
              this.selectedCustomAssetGrp.splice(dupCount, 1);
            }
          }
        } else {
          /* When child node/checkbox is selected, attach the child value in the attributes array */
          if (this.selectedCustomAssetGrp.every(val => val.code !== rowData.parent.code)) {
            obj = [];
            if (rowData.data.code !== this.emtrConstant.ruleSteps.step2.operatingNetExpenseRatioCode) {
              obj.push({
                name: rowData.data.name,
                code: rowData.data.code ? rowData.data.code : '',
                value: 'true',
              });
              this.selectedCustomAssetGrp.push({
                id: rowData.parent.data.id,
                name: rowData.parent.data.name,
                code: rowData.parent.data.code ? rowData.parent.data.code : '',
                attributes: obj,
              });
            } else if (this.emtrConstant.ruleSteps.step2.operatingNetExpenseRatioCode === rowData.data.code) {
              const selectedRuleValue = JSON.parse(JSON.stringify(rowData.data));
              selectedRuleValue.value = rowData.selectedValueIs;
              delete selectedRuleValue.htmlType;
              delete selectedRuleValue.order;
              delete selectedRuleValue.parent;
              obj.push(selectedRuleValue);
              this.selectedCustomAssetGrp.push({
                id: rowData.parent.data.id,
                name: rowData.parent.data.name,
                code: rowData.parent.data.code ? rowData.parent.data.code : '',
                attributes: obj,
              });
            }
          } else {
            /* When more than 1 child node/checkbox is selected for a parent, attach the child value in the attributes array */
            let parentArray = [];
            this.selectedCustomAssetGrp.forEach(selectedNode => {
              obj = [];
              parentArray = [];
              const childrenArray = this.selectedNodes.filter(val => (val.parent && (val.parent.code === selectedNode.code && selectedNode.attributes.length > 0)));
              childrenArray.forEach(company => {
                parentArray = [];
                if (company.data.code !== this.emtrConstant.ruleSteps.step2.operatingNetExpenseRatioCode) {
                  obj.push({
                    name: company.data.name,
                    code: company.data.code ? company.data.code : '',
                    value: 'true',
                  });
                } else if (this.emtrConstant.ruleSteps.step2.operatingNetExpenseRatioCode === rowData.data.code) {
                  const selectedRuleValue = JSON.parse(JSON.stringify(rowData.data));
                  selectedRuleValue.value = rowData.selectedValueIs;
                  delete selectedRuleValue.htmlType;
                  delete selectedRuleValue.order;
                  delete selectedRuleValue.parent;
                  obj.push(selectedRuleValue);
                }
                if (obj.length > 0) {
                  parentArray = company.parent.data.sscLevel;
                }
              });
              this.customAssetGrp.push({
                id: selectedNode.id,
                name: selectedNode.name,
                code: selectedNode.code ? selectedNode.code : '',
                attributes: obj,
              });
              const dupCount = this.customAssetGrp.findIndex(a => a.code === selectedNode.code && a.attributes !== obj);
              if (dupCount !== -1) {
                this.customAssetGrp.splice(dupCount, 1);
              }
            });
            this.selectedCustomAssetGrp = this.customAssetGrp;
          }
        }
      });

      /* Process DIGITAL asset groups - different logic: always include attributes */
      if (this.selectedDigitalNodes && this.selectedDigitalNodes.length > 0) {
        /* Remove any existing digital asset group entries to avoid duplicates */
        this.selectedCustomAssetGrp = this.selectedCustomAssetGrp.filter(
          grp => grp.code !== this.emtrConstant.ruleSteps.step2.digitalAssetGroupCode
        );
        
        this.selectedDigitalNodes.forEach(rowData => {
          // Check if this is a parent node
          if (rowData.children && rowData.children.length > 0) {
            // Parent selected - include ALL children attributes (Direct + Indirect)
            const childAttr = rowData.children.map(childEl => {
              return {
                name: childEl.data.name,
                code: childEl.data.code ? childEl.data.code : '',
                value: 'true',
              };
            });
            
            this.selectedCustomAssetGrp.push({
              id: rowData.data.id,
              name: rowData.data.name,
              code: rowData.data.code ? rowData.data.code : '',
              attributes: childAttr,
            });
          } else if (rowData.parent) {
            // Child node selected - check if parent is also in selectedDigitalNodes
            const parentAlsoSelected = this.selectedDigitalNodes.some(node => 
              node.data.code === rowData.parent.data.code && node.children && node.children.length > 0
            );
            
            // Skip if parent is already selected (it will include all children)
            if (parentAlsoSelected) {
              return;
            }
            
            // Check if parent already exists to include that specific child selected
            const existingParent = this.selectedCustomAssetGrp.find(grp => grp.code === rowData.parent.data.code);
            
            if (existingParent) {
              // Add this child to existing parent if not already there
              const childExists = existingParent.attributes.some(attr => attr.code === rowData.data.code);
              if (!childExists) {
                existingParent.attributes.push({
                  name: rowData.data.name,
                  code: rowData.data.code ? rowData.data.code : '',
                  value: 'true',
                });
              }
            } else {
              // Create new parent entry with this child
              this.selectedCustomAssetGrp.push({
                id: rowData.parent.data.id,
                name: rowData.parent.data.name,
                code: rowData.parent.data.code ? rowData.parent.data.code : '',
                attributes: [{
                  name: rowData.data.name,
                  code: rowData.data.code ? rowData.data.code : '',
                  value: 'true',
                }],
              });
            }
          }
        });
      }

    this.emitSelectedAGandPresetRule(this.presetRuleId, this.presetRuleInput, this.selectedCustomAssetGrp, false);
  }

  childNodeSelected(el) {
    /* Clear out the miscellaneous asset group selection, when any attribute of a regular asset group is selected */
    this.miscellaneousAssetGrpForm.reset();

    /* Clear security value selected on Review Security Details before setting the new values */
    this.multiLevelSecurityType = [];

    const isNetExpenseSelected = (this.selectedAction && this.selectedAction.name.indexOf('=') !== '-1');
    if (isNetExpenseSelected) {
      this.assetGroupsTreeData.forEach((assetGroupType: any) => {
        if (assetGroupType.data.code === this.emtrConstant.ruleSteps.step2.mutualFundsCode && (this.businessUnit === 'RBS' || this.businessUnit === '')) {
          /* Push OER % only if the selectedAction contains any value */
          if (this.selectedAction.value !== '') {
            let macthedIndex = -1;
            for (let i = 0; i < this.selectedNodes.length; i++) {
              if (assetGroupType.children[assetGroupType.children.length - 1] && this.selectedNodes[i].data && this.selectedNodes[i].data.code === assetGroupType.children[assetGroupType.children.length - 1].data.code) {
                macthedIndex = i;
              }
            }
            if (macthedIndex >= 0) {
              this.selectedNodes[macthedIndex].selectedValueIs = this.selectedAction.value;
            } else {
              assetGroupType.children[assetGroupType.children.length - 1].selectedValueIs = this.selectedAction.value;
              this.selectedNodes.push(assetGroupType.children[assetGroupType.children.length - 1]);
            }
          } else {
            /* When OER dropdown is set to default selection i.e 'Select' */
            const modifiedSelectedNodes = this.selectedNodes;
            for (let i = 0; i < this.selectedNodes.length; i++) {
              /* If selectedNodes arr contains OER data then remove the data from the arr */
              if (assetGroupType.children[assetGroupType.children.length - 1] && this.selectedNodes[i].data && this.selectedNodes[i].data.code === assetGroupType.children[assetGroupType.children.length - 1].data.code) {
                modifiedSelectedNodes.splice(i, 1);
              }
            }
            this.selectedNodes = modifiedSelectedNodes;
            
           // Check if Mutual Funds parent has any other children selected
            const hasMFChildren = this.selectedNodes.some(node => 
              node.parent && node.parent.data.code === this.emtrConstant.ruleSteps.step2.mutualFundsCode
            );
            
            // If no MF children are selected, remove the partial selection from parent
            if (!hasMFChildren) {
              this.rowNodeArray.forEach(rowData => {
                if (rowData.data.code === this.emtrConstant.ruleSteps.step2.mutualFundsCode) {
                  rowData.partialSelected = false;
                }
              });
            }
          }
        }
      });
    }

    /*Add or remove ETF-Limited Prtnership from the selectedNodes array based on the presence of EQ Limited Partnership */
    let newArray = [];
    this.selectedNodes.forEach(node => {
      newArray.push(node);
    });
    const indexOfeqLtdPship = newArray.findIndex(x => x.data.code === this.emtrConstant.presetRules.eqLimitedPartnershipCode);
    if (newArray.findIndex(x => x.parent && x.parent.data.code === this.emtrConstant.presetRules.etfCode) !== -1) {
      newArray = newArray.filter((node) => node.data.code !== this.emtrConstant.presetRules.etfCode);
    }
    if (indexOfeqLtdPship !== -1 && newArray.findIndex(x => x.data.code === this.emtrConstant.presetRules.etfLimitedPartnershipCode) === -1 && newArray.findIndex(y => y.data.code === this.emtrConstant.presetRules.etfCode) === -1) {
      this.etfLimPartnershipObj['parent'].partialSelected = true;
      newArray.push(this.etfLimPartnershipObj);
    } else if (indexOfeqLtdPship === -1) {
      newArray = newArray.filter((node) => node.data.code !== this.emtrConstant.presetRules.etfLimitedPartnershipCode);
    }
    this.selectedNodes = [...newArray];

    /* Logic to allow only single attribute selection for Option asset group */
    /* Filtering out all the child nodes selected for the Option asset group */
    const optionAGAttributes = this.selectedNodes.filter(val => val.parent && val.parent.data.code === this.emtrConstant.ruleSteps.step2.optionsAG);
    const arrLength = optionAGAttributes.length;
    /* Checking if more than one child is selected for the Option asset group */
    if (optionAGAttributes && arrLength > 1) {
      /* If more than 1 child node is selected then keep the last/latest selected child node and remove the other children nodes */
      /* Here we are first finding the index of the child node other than the latest selected child, and delete numbe will depend
      on the length of the filtered value, hence it is arrLength-1. except the last value in the array all the other values will be spliced */
      this.selectedNodes.splice(this.selectedNodes.findIndex(val => val.parent && val.parent.data.code === this.emtrConstant.ruleSteps.step2.optionsAG && val.data.code !== optionAGAttributes[arrLength - 1].data.code), arrLength - 1);
    }
    const newSelectedArr = this.selectedNodes;
    /* Remove the parent node from selectedNode when the corresponding child node/checkbox is selected  */
    this.selectedNodes.forEach((rowData) => {
      if (rowData.parent) {
        rowData.parent.partialSelected = true;
        const parentIndex = newSelectedArr.findIndex(a => a.data.code === rowData.parent.code);
        if (parentIndex !== -1) {
          newSelectedArr.splice(parentIndex, 1);
          const index = newSelectedArr.findIndex(a => a.children && a.data.code === rowData.parent.code);
          if (index !== -1) {
            newSelectedArr.splice(index, 1);
          }
        }
      }
    });
    this.selectedNodes = [...newSelectedArr];
    if (this.businessUnit === 'DBS') {
      if ((this.newSelectedNodes && this.newSelectedNodes.length === 0) || (this.selectedNodes && this.selectedNodes.length === 0)) {
        this.newSelectedNodes = this.selectedNodes;
      } else {
        this.newSelectedNodes.forEach(val => {
          const localArr = this.selectedNodes.filter(childVal => childVal.parent && childVal.parent.code === val.code);
          if (localArr && localArr.length > 0) {
            this.selectedNodes.splice(this.selectedNodes.indexOf(localArr[0]), 1);
          }
        });
        this.newSelectedNodes = this.selectedNodes;
      }
      this.updateCheckboxCssForDBS();
    } else {
      this.updateCheckboxCss();
    }

    /* To form the asset group array for Custom Asset Group preset rule -> to send in api payload */
    this.getSelectedAssetGroups();
  }
  
  // Regular asset group handlers
  onNodeUnselect(event: TreeTableNodeUnSelectEvent){
    this.setWarningMsg();
    this.parentNodeSelected(event.originalEvent);
  }

  onNodeSelect(event: TreeTableNodeSelectEvent) {
    this.setWarningMsg();
    if (event.node.parent !== null) {
      this.childNodeSelected(event.originalEvent);
    } else {
      this.parentNodeSelected(event.originalEvent);
    }
  }

  onSelectionChange() {
    if (this.businessUnit === 'DBS') {
      this.updateCheckboxCssForDBS()
    } else {
      this.updateCheckboxCss();
    }
    this.cdr.detectChanges();
  }

  onSelectChangeEvent(event: SelectChangeEvent){
    this.setWarningMsg();
    setTimeout(() => {
      this.childNodeSelected(event.originalEvent);
      this.cdr.detectChanges();
    })
  }

  // Digital Asset Groups hanlers
  onDigitalNodeSelect(event: TreeTableNodeSelectEvent) {
    /* Clear out the miscellaneous asset group selection, when any digital asset group is selected */
    this.miscellaneousAssetGrpForm.reset();
    this.setWarningMsg();
    // For RBS, call immediately. For DBS, will be called in onDigitalSelectionChange
    if (this.businessUnit !== 'DBS') {
      this.getSelectedAssetGroups();
    }
  }

  onDigitalNodeUnselect(event: TreeTableNodeUnSelectEvent) {
    this.setWarningMsg();

    // For RBS, call immediately. For DBS, will be called in onDigitalSelectionChange
    if (this.businessUnit !== 'DBS') {
      this.getSelectedAssetGroups();
    }
  }

  onDigitalSelectionChange() {
    this.cdr.detectChanges();

    // For DBS, call getSelectedAssetGroups after selection change
    if (this.businessUnit === 'DBS') {
      this.getSelectedAssetGroups();
    }
  }
  
  parentNodeSelected(el) {
    /* Clear out the miscellaneous asset group selection, when any regular asset group is selected */
    this.miscellaneousAssetGrpForm.reset();

    /* Clear security value selected on Review Security Details before setting the new values */
    this.multiLevelSecurityType = [];

    const selectedArrWithoutChildren = this.selectedNodes;
    /* Remove all the child nodes from selectedNode when the corresponding parent node/checkbox is selected  */
    this.selectedNodes.forEach(selectedNode => {
      const childrenArray = selectedArrWithoutChildren.filter(child => child.parent && (selectedNode.code === child.parent.code));
      childrenArray.forEach(company => {
        if (company.parent && (selectedNode.code === company.parent.code)) {
          selectedArrWithoutChildren.splice(selectedArrWithoutChildren.indexOf(company), 1);
          if (selectedNode.code === this.emtrConstant.ruleSteps.step2.mutualFundsCode) {
            this.selectedAction = {name: 'Select', value: ''};
            this.selectedActionDropdownValue.emit(undefined);
          }
        }
      });
    });
    this.selectedNodes = selectedArrWithoutChildren;
    /* Remove ETF LP if ETF is selected as a parent otherwise push ETF-LP in the selectedNodes array if EQ-LP is present */
    const indexOfeqLtdPship = this.selectedNodes.map(x => x.data.code).indexOf(this.emtrConstant.presetRules.eqLimitedPartnershipCode);
    const indexOfetfLtdPship = this.selectedNodes.map(x => x.data.code).indexOf(this.emtrConstant.presetRules.etfLimitedPartnershipCode);
    const etfLPLength = this.selectedNodes.filter(o => o.data.parent === this.emtrConstant.presetRules.exchangeTradedFunds).length > 1;
    
    // Check if there are other ETF children selected besides ETF-LP
    const otherEtfChildren = this.selectedNodes.filter(node => 
      node.parent && 
      node.parent.data.code === this.emtrConstant.presetRules.etfCode && 
      node.data.code !== this.emtrConstant.presetRules.etfLimitedPartnershipCode
    );
    
    if (indexOfeqLtdPship === -1 && this.selectedNodes.map(x => x.data.code).indexOf(this.emtrConstant.presetRules.etfLimitedPartnershipCode) !== -1) {
      /*  partialSelected is set to false of ETF when EQ-LP is unchecked as ETP-LP is unchecked automatically and to not have hyphen on ETF parent*/
      this.selectedNodes.map(y => {
        if (y.data.code === this.emtrConstant.presetRules.etfLimitedPartnershipCode) {
          // Only set partialSelected to false if there are no other ETF children selected
          if (otherEtfChildren.length === 0) {
            y.parent.partialSelected = false;
          } else {
            y.parent.partialSelected = true;
          }
        }
      });
      this.selectedNodes = this.selectedNodes.filter((node) => node.data.code !== this.emtrConstant.presetRules.etfLimitedPartnershipCode);
    } else if (indexOfeqLtdPship !== -1 && indexOfetfLtdPship === -1 && this.selectedNodes.map(x => x.data.code).indexOf(this.emtrConstant.presetRules.etfCode) === -1) {
      const newObj = this.etfLimPartnershipObj;
      newObj['parent'].partialSelected = true;
      this.selectedNodes.push(newObj);
    }
    etfLPLength && this.selectedNodes.map(y => { if (y.parent) { y.parent.partialSelected = true; } });
    
    // Ensure ETF parent has correct partialSelected state after removal of ETF-LP
    if (indexOfeqLtdPship === -1 && otherEtfChildren.length > 0) {
      this.rowNodeArray.forEach(rowData => {
        if (rowData.data.code === this.emtrConstant.presetRules.etfCode) {
          rowData.partialSelected = true;
        }
      });
    }
    
    this.updateCheckboxCss();
    if (this.businessUnit === 'DBS') {
      if ((this.newSelectedNodes && this.newSelectedNodes.length === 0) || (this.selectedNodes && this.selectedNodes.length === 0)) {
        this.newSelectedNodes = this.selectedNodes;
      } else {
        this.newSelectedNodes.forEach(val => {
          const localArr = this.selectedNodes.filter(parent => val.parent && parent.code === val.parent.code);
          if (localArr && localArr.length > 0) {
            this.selectedNodes.splice(this.selectedNodes.indexOf(localArr[0]), 1);
          }
        });
        this.newSelectedNodes = this.selectedNodes;
      }
      this.updateCheckboxCssForDBS();
    } else {
    /* Remove the css from all the child nodes when the corresponding parent node/checkbox is selected  */
      this.selectedNodes.forEach(id => {
        // Dynamically find the row by matching asset group ID from rowNodeArray
        const wholeArray = this.getRowElementByNodeId(id.data.id);
      const tdArray = wholeArray && wholeArray.querySelectorAll('td'); // NOSONAR
      if (tdArray) {
        tdArray.forEach((element, i) => {
          /*Avoiding the first td to not to remove the check icon since it is a parent*/
          const entireCheckedArray1 = element.querySelector('.p-checkbox-box'); // NOSONAR
          const entireCheckedArray2 = element.querySelector('.p-checkbox-icon'); // NOSONAR
          if (i > 0) {
            if (entireCheckedArray1 && entireCheckedArray2) {
              entireCheckedArray1.classList.remove('p-highlight'); // NOSONAR
              entireCheckedArray2.classList.remove('pi'); // NOSONAR
              entireCheckedArray2.classList.remove('pi-check'); // NOSONAR
            }
          }
        });
      }
    });
  }
    setTimeout(() => {
    this.highlightParent();
    });
    this.getSelectedAssetGroups();
  }

  private getRowElementByNodeId(nodeId: number): Element | null {
    const allRows = this.el.nativeElement.querySelectorAll('tr.assetGrptr'); // NOSONAR
    const nodeIndex = this.rowNodeArray.findIndex(node =>
      !node.parent && node.data && node.data.id === nodeId
    );

    if (nodeIndex !== -1 && nodeIndex < allRows.length) {
      return allRows[nodeIndex];
    }
    return null;
  }

  highlightParent() {
    this.selectedNodes.forEach(id => {
      if (id.parent) {
        // Dynamically find the row by matching parent asset group ID from rowNodeArray
        const wholeArray = this.getRowElementByNodeId(id.parent.data.id);
        const tdArray = wholeArray && wholeArray.querySelectorAll('td'); // NOSONAR
        if (tdArray) {
          tdArray.forEach((element, i) => {
            if (element.innerText) {
              /*Avoiding the first td to not to remove the check icon since it is a parent*/
              const entireCheckedArray1 = element.querySelector('.p-checkbox-box'); // NOSONAR
              const entireCheckedArray2 = element.querySelector('.p-checkbox-icon'); // NOSONAR
              if (i === 0) {
                if (entireCheckedArray1 && entireCheckedArray2) {
                  entireCheckedArray1.classList.add('p-highlight');
                  entireCheckedArray2.classList.add('pi');
                  entireCheckedArray2.classList.remove('pi-minus');
                  entireCheckedArray2.classList.add('pi-check');
                }
              }
            }
          });
        }
      }
    });
  }

  miscellaneousAssetGroupSelected() {
    /* Custom flag will be set to true for MF preset rules selection only and for miscellaneous asset group selection custom flag will be set to false */
    this.custom = false;

    /* Clear assetGroupsSelection, selectedNodes and selectedArr before setting the new values */
    this.assetGroupsSelection = [];
    this.selectedNodes = [];
    this.selectedDigitalNodes = [];

    /* Clear security value selected on Review Security Details before setting the new values */
    this.multiLevelSecurityType = [];

    /* Set 'Select' as default selection in the OER dropdown of general asset group */
    this.selectedAction = {name: 'Select', value: ''};

    /* Add and mark partialSelected field as false for all the nodes */
    const localRowNode = this.rowNodeArray;
    localRowNode.forEach(nodeVal => {
      nodeVal.partialSelected = false;
    });

    const wholeArray = this.el.nativeElement.querySelectorAll('td.assetGrptd');
    /* Remove the css from general asset group checkboxes */
    wholeArray.forEach(element => {
      this.updateAssetGroupSelection('remove', '', element);
    });
    
    setTimeout(() => {
      const localForm = this.miscellaneousAssetGrpForm.getRawValue();
      const localAssetGrp = [];
      this.miscAssetGroups.forEach(miscVal => {
        if (localForm[miscVal.name] && localForm[miscVal.name].length > 0) {
          /* This is to load the securites on the review security modal when user makes a selection in miscellaneous asset group section */
          const secCatgs = {
            secCatgs1: miscVal.secCatgs1 ? miscVal.secCatgs1 : [],
            secCatgs2: miscVal.secCatgs2 ? miscVal.secCatgs2 : [],
            secCatgs3: miscVal.secCatgs3 ? miscVal.secCatgs3 : []
          }
          this.fetchAndPupulateSecurityTypeList(secCatgs);

          localAssetGrp.push({
            id: miscVal.id,
            name: miscVal.name,
            code: miscVal.code,
            attributes: miscVal.attributes ? miscVal.attributes : [],
          });
        }
      });
      this.presetRuleInput = this.emtrConstant.presetRules.customAssetGroupText;
      this.presetRuleId = this.customAssetGrpId;
      this.selectedActionDropdownValue.emit(undefined);

      this.emitSelectedAGandPresetRule(this.customAssetGrpId, this.emtrConstant.presetRules.customAssetGroupText, localAssetGrp, true);
    }, 0);
  }

  updateMiscAssetGroupSelection() {
    /* Custom flag will be set to true for MF preset rules selection only and for miscellaneous asset group selection custom flag will be set to false */
    this.custom = false;
    const localForm = this.miscellaneousAssetGrpForm.getRawValue();
    const localAssetGrp = [];
    const secCatgs = {
      secCatgs1: [],
      secCatgs2: [],
      secCatgs3: []
    }
    this.assetGroupsInput.forEach(miscVal => {
      /* This section is for loading the securites of the selected miscellaneous asset group, when user lands on rule step2 from step1/step3 */
      this.assetGroups.some(grp => miscVal.code === grp.code && grp.secCatgs1 ? grp.secCatgs1.filter(security => secCatgs.secCatgs1.push(security)) : '');
      this.assetGroups.some(grp => miscVal.code === grp.code && grp.secCatgs2 ? grp.secCatgs2.filter(security => secCatgs.secCatgs2.push(security)) : '');
      this.assetGroups.some(grp => miscVal.code === grp.code && grp.secCatgs3 ? grp.secCatgs3.filter(security => secCatgs.secCatgs3.push(security)) : '');

      this.miscellaneousAssetGrpForm.get(miscVal.name).setValue([miscVal.name]);
      localAssetGrp.push({
        id: miscVal.id,
        name: miscVal.name,
        code: miscVal.code,
        attributes: miscVal.attributes,
      });
    });
    /* Call fetchAndPupulateSecurityTypeList to populate the modal with formed secCatgs  */
    this.fetchAndPupulateSecurityTypeList(secCatgs);
    this.emitSelectedAGandPresetRule(this.customAssetGrpId, this.emtrConstant.presetRules.customAssetGroupText, localAssetGrp, true);
  }

  emitSelectedAGandPresetRule(presetRuleChange, presetRuleKey, assetGroupChange, micAGFlag) {
    /* Emit the selected preset rule and the corresponding asset Groups to the parent component */
    this.presetRuleChange.emit(presetRuleChange);
    this.presetRuleKey.emit(presetRuleKey);
    this.assetGroupChange.emit(assetGroupChange);
    this.micAssetGroupSelectedFlag.emit(micAGFlag);
    this.customValue.emit(this.custom);
  }

  /* Open the review security type details modal when selections exist */
  openSecurityType(event: Event) {
    this.reviewSecurityTypeView.openModal(event);
  }

  formatSecurities(securities, level) {
    return securities.map(item => {
      return {
        data: {
          desc: item.secTypNm,
          code: item.secTypCd,
          level
        }
      };
    });
  }

  recurrsive(data, array) {
    if(data?.subLevels && Array.isArray(data.subLevels)){
      data.subLevels.forEach(sublevel => {
        const {subLevels, ...anotSublevels} = sublevel;
        array.push(anotSublevels);
        this.recurrsive(sublevel, array)
      });
      return array;
    } else {
      return data;
    }
  }

  fetchAndPupulateSecurityTypeList(SecurityValue) {
    if (this.securityData && this.securityData.length ===0) {
      this.ruleService.getSecurities(false).subscribe((data: any) => {
        this.securityData = data.esoLevels;
        this.populateSecurityTypeData(SecurityValue);
      });
    } else {
      this.populateSecurityTypeData(SecurityValue);
    }
  }
  populateSecurityTypeData(SecurityValue) {
    const securityData = JSON.parse(JSON.stringify(this.securityData));
    if (securityData) {
      const secCatgs1 = this.formatSecurities(SecurityValue.secCatgs1, 'SC1');
      const secCatgs2 = this.formatSecurities(SecurityValue.secCatgs2, 'SC2');
      const secCatgs3 = this.formatSecurities(SecurityValue.secCatgs3, 'SC3');
      const selectedValues = secCatgs1.concat(secCatgs2).concat(secCatgs3);
      selectedValues.forEach(selectedData => {
        securityData.forEach(secData => {
          if (JSON.stringify(secData).indexOf('\"code\":\"' + selectedData.data.code + '"') !== -1) {
            if (!this.multiLevelSecurityType[secData.desc]) {
              this.multiLevelSecurityType[secData.desc] = [];
            }
            if (selectedData.data.level === 'SC1') {
              this.ruleService.appendUniqueSecurityNodes(this.multiLevelSecurityType[secData.desc], this.ruleService.formatSecurityNodes([{...secData}]));
            } else if (selectedData.data.level === 'SC2') {
              secData.subLevels.forEach(secSubLevelData => {
                if (JSON.stringify(secSubLevelData).indexOf('\"code\":\"' + selectedData.data.code + '"') !== -1) {
                  this.ruleService.appendUniqueSecurityNodes(this.multiLevelSecurityType[secData.desc], this.ruleService.formatSecurityNodes([{...secSubLevelData}]));
                }
              });
            } else {
              this.ruleService.appendUniqueSecurityNodes(this.multiLevelSecurityType[secData.desc], this.ruleService.formatSecurityNodes([selectedData.data]));
            }
          }
        });
      });
      this.updateSecurityValues(this.multiLevelSecurityType);
    }
  }

  /* Setting the formObj and displaying the selected Data in Page*/
  updateSecurityValues(selectedValues) {
    this.multiLevelSecurityType = Object.assign({}, selectedValues);
    const wholeArray = Object.assign({}, this.multiLevelSecurityType);
    Object.keys(wholeArray).forEach(key => {
      wholeArray[key].forEach(keys => {
        if (keys.children) {
          keys.data.selected = 'ALL';
          keys.children.forEach(record => {
            wholeArray[key] = wholeArray[key].filter(item => item.data.code !== record.data.code);
          });
        }
      });
      /* when we are getting few securities from preset and few from asset group, and the formed secCatgs2 has all the Level2 selected then we are making the Level1 selection for that security */
      const secCatgs = {
        secCatgs1: [],
        secCatgs2: [],
        secCatgs3: []
      }
      /* Clearing this.multiLevelSecurityType[sec.desc] so that duplicate data are not pushed so the 'Select All' checkbox on modal is selected when all securities are selected */
      this.securityData.some(sec => sec.desc == key && sec.subLevels.length === wholeArray[key].length ? (secCatgs.secCatgs1.push({secTypNm: sec.desc, secTypCd: sec.code}), this.multiLevelSecurityType[sec.desc] = [],this.populateSecurityTypeData(secCatgs)) : '')
    });
  }

  /* For only DBS. Here using selectionKeys to check the parent and child checboxes*/
  onSelectKeysChange(event) {
    if (this.businessUnit === 'DBS') {
      const assetGroupSelect = Object.keys(event).length === 0 ?  true : false;
      this.selectedNodes = Object.keys(event).length !== 0 ? this.mapKeysToNodes(event, this.assetGroupsTreeData) : this.sharedService.selectedCachedNode;
      /*Removing the CSS added manually as the treetable selectionKeys takes care of checkmarks*/
      const wholeArray = this.el.nativeElement.querySelectorAll('td.assetGrptd');
      wholeArray.forEach(element => {
        this.updateAssetGroupSelection('remove', '', element);
      });
      if (Object.keys(event).length !== 0) {
        this.clearSelectedNode =[];
        this.clearSelectedNode.push(event);
        this.getSelectedAssetGroups();
        this.sharedService.selectedCachedNode = this.selectedNodes;

      } else {
        this.selectedNodes.forEach(data => {
          this.selectionKeys[data.data.code] = { checked: false, partialChecked: false };
          if (data.children && data.children.length > 0) {
            data.children.forEach(child => {
              this.selectionKeys[child.data.code] = { checked: false, partialChecked: false };
            });
          }
        });
        /* Clear selectedNodes and multiLevelSecurityType so that subsequent calls to
           getSelectedAssetGroups() (triggered by onNodeUnselect) do not re-populate
           the security type data with stale cached values after a full deselect. */
        this.selectedNodes = [];
        this.multiLevelSecurityType = {};
        this.assetGroupsSelection = [];
        const clearEmitted = this.clearAssetGroup();
        if (assetGroupSelect && !clearEmitted) {
          this.emitSelectedAGandPresetRule(this.presetRuleId, this.presetRuleInput, [], false);
        }
      }
    }
  }

  private mapKeysToNodes(keys: { [key: string]: { checked: boolean } }, nodes: TreeNode[]): TreeNode[] {
    const result: TreeNode[] = [];
    for (const node of nodes) {
      if (keys[node.data.code]?.checked) {
        result.push(node);
      }
    }
    return result;
  }

  clearAssetGroup(): boolean {
    if(this.clearSelectedNode.length === 1 && this.businessUnit === 'DBS') {
      let emitted = false;
      this.clearSelectedNode.forEach(e => {
        if(!e?.al?.checked || !e?.mf?.checked) {
          this.emitSelectedAGandPresetRule(this.presetRuleId, this.presetRuleInput, this.assetGroupsSelection, false);
          emitted = true;
        }
      });
      return emitted;
    }
    return false;
  }
  validateRoleForOBP() {
    return this.sharedService.checkEntitlements(this.entitlementConst.navUUID.ngOMS.manageGlobalRuleObp.uuid, '', '') &&
    this.formDataService.formData.ruleSubCategory === this.getSharedConstant.openBrokerage.subType &&
    this.sharedService.checkEntitlements(this.entitlementConst.navUUID.emtrAccess.manageGlobalRule.uuid, '', '');
  }
  assignAssetGroupForOBPRule() {
    setTimeout(() => {
      const { mode, ruleSubCategory } = this.formDataService.formData;
      if ((mode === '') && ruleSubCategory === this.getSharedConstant.openBrokerage.subType) {
        const selectedNodes = this.rowNodeArray.filter(node => node.data.code === this.emtrConstant.ruleSteps.step2.optionsAG);
        selectedNodes.forEach(node => {
          node.checked = true;
        });
        this.selectedNodes = selectedNodes;
        this.updateCheckboxCss();
        this.getSelectedAssetGroups();
      }
    }, 500);
  }

  private applyTreeCheckboxInputLabels() {
    const root = this.el?.nativeElement as HTMLElement | null;
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    const treeCheckboxHosts = root.querySelectorAll('p-treetablecheckbox'); // NOSONAR
    let hostInputCounter = 0;

    treeCheckboxHosts.forEach((host: Element) => {
      const input = host.querySelector('input.p-checkbox-input') as HTMLInputElement; // NOSONAR
      if (!input) {
        return;
      }

      const hostIdAttr = (host.getAttribute('id') || '').trim();
      const mappedSpanId = hostIdAttr
        .replace('_assetGroupCheckbox', '_assetGroupLabel')
        .replace('_attributeCheckbox', '_attributeLabel')
        .replace('_digitalAssetGroupCheckbox', '_digitalAssetGroupLabel')
        .replace('_digitalAttributeCheckbox', '_digitalAttributeLabel');
      const mappedSpan = mappedSpanId ? document.getElementById(mappedSpanId) : null;
      const mappedLabelText = (mappedSpan?.textContent || '').trim();
      const hostLabel = mappedLabelText || (host.getAttribute('aria-label') || '').trim();
      if (!hostLabel) {
        return;
      }

      hostInputCounter += 1;
      const hostId = hostIdAttr || `preset-tree-host-${hostInputCounter}`;
      const safeHostId = hostId.replace(/[^A-Za-z0-9_-]/g, '-');
      const inputId = input.id || `${safeHostId}_input`;
      const labelId = `${inputId}-a11y-label`;

      input.id = inputId;
      input.removeAttribute('aria-label');
      input.removeAttribute('aria-describedby');

      const parent = host.parentElement;
      if (!parent) {
        return;
      }

      if (mappedSpanId && mappedSpan) {
        input.setAttribute('aria-labelledby', mappedSpanId);

        const staleLabel = document.getElementById(labelId) as HTMLLabelElement | null;
        if (staleLabel) {
          staleLabel.remove();
        }
        return;
      }

      input.setAttribute('aria-labelledby', labelId);

      const existingLabel = document.getElementById(labelId) as HTMLLabelElement | null;
      if (existingLabel) {
        existingLabel.setAttribute('for', inputId);
        existingLabel.textContent = hostLabel;
      } else {
        const srLabel = document.createElement('label');
        srLabel.id = labelId;
        srLabel.className = 'sr-only';
        srLabel.setAttribute('for', inputId);
        srLabel.textContent = hostLabel;
        parent.appendChild(srLabel);
      }
    });

    const tableCells = root.querySelectorAll('td.assetGrptd, td.digitalAssetGrptd'); // NOSONAR
    let generatedIdCounter = 0;

    tableCells.forEach((cell: Element) => {
      const inputs = cell.querySelectorAll('p-treeTableCheckbox input.p-checkbox-input') as NodeListOf<HTMLInputElement>; // NOSONAR
      if (!inputs || inputs.length === 0) {
        return;
      }

      const labelElement = cell.querySelector(
        'span[id$="_assetGroupLabel"], span[id$="_attributeLabel"], span[id$="_digitalAssetGroupLabel"], span[id$="_digitalAttributeLabel"]'
      ) as HTMLElement;

      const labelText = (labelElement?.textContent || '').trim();
      if (!labelText) {
        return;
      }

      inputs.forEach((input: HTMLInputElement) => {
        generatedIdCounter += 1;
        const inputId = input.id || `preset-tree-checkbox-${generatedIdCounter}`;
        const generatedLabelId = `${inputId}-a11y-label`;
        const visibleLabelId = labelElement.id;

        input.id = inputId;
        input.removeAttribute('aria-label');
        input.removeAttribute('aria-describedby');
        if (visibleLabelId && document.getElementById(visibleLabelId)) {
          input.setAttribute('aria-labelledby', visibleLabelId);

          const staleLabel = document.getElementById(generatedLabelId) as HTMLLabelElement | null;
          if (staleLabel) {
            staleLabel.remove();
          }
          return;
        }

        input.setAttribute('aria-labelledby', generatedLabelId);

        const existingLabel = document.getElementById(generatedLabelId) as HTMLLabelElement | null;
        if (existingLabel) {
          existingLabel.setAttribute('for', inputId);
          existingLabel.textContent = labelText;
          return;
        }

        const srLabel = document.createElement('label');
        srLabel.id = generatedLabelId;
        srLabel.className = 'sr-only';
        srLabel.setAttribute('for', inputId);
        srLabel.textContent = labelText;
        cell.appendChild(srLabel);
      });
    });
  }
}
